import { Box, Typography } from '@mui/material';

type Props = {
  result: string;
};

export const EditQueryResult = ({ result }: Props) => {
  const isEmpty = (result ?? '').length === 0;

  return (
    <Box sx={{ marginTop: 2 }}>
      <Typography>Result</Typography>
      <Box sx={{ border: '1px solid #ccc', padding: 2, marginTop: 1 }}>
        <Typography variant={isEmpty ? 'body2' : 'body1'}>{isEmpty ? 'Nothing to show.' : result}</Typography>
      </Box>
    </Box>
  );
};
